var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSynergiesFilterCriteria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M11.5 10.5h4v4h-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1v1.71l-6 6V15H6V8.71l-6-6V1h16zm-1 1H1v.29l6 6V14h2V8.29l6-6V2z",
    fill: "currentColor"
  })));
}

export default SvgSynergiesFilterCriteria;